export const SET_MISSIONS = 'SET_MISSIONS';
export const SET_MISSION = 'SET_MISSION';
export const ADD_MISSION = 'ADD_MISSION';
export const UPDATE_MISSION = 'UPDATE_MISSION';
export const REMOVE_MISSION = 'REMOVE_MISSION';
export const CLEAR_MISSION = 'CLEAR_MISSION';
export const CLEAR_MISSIONS = 'CLEAR_MISSIONS';
